import React, { useEffect, useState } from "react";
import { Modal, Button, Table, notification } from "antd";
import moment from "moment";
import { ImmoService } from "../Services/ImmoService";

const PassComptaImmo = ({ isVisible, setIsVisible, tableData }) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const immoService = new ImmoService();

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      if (isVisible) {
        try {
          const addData = [...tableData];
          const result = await immoService.addPassCompta(addData);
          setData(result);
        } catch (error) {
          notification.error({
            message: "Erreur",
            description:
              "Impossible de charger les données pour la comptabilisation.",
          });
        } finally {
          setLoading(false);
        }
      }
    };
    fetchData();
  }, [isVisible]);

  const handleClose = () => {
    setIsVisible(false);
  };

  const handleComptabiliser = async () => {
    try {
      const response = await immoService.addComptaImmo(data);
      notification.success({
        message: "Comptabilisation réussie",
        description: "Les données ont été comptabilisées avec succès.",
      });
    } catch (error) {
      notification.error({
        message: "Échec de la comptabilisation",
        description:
          "Une erreur est survenue lors de la comptabilisation. Veuillez réessayer.",
      });
    }
  };
  const columnHeaderStyle = {
    backgroundColor: "#010f1c",
    color: "white",
    paddingRight: 5,
  };

  const detailColumns = [
    {
      title: <div style={columnHeaderStyle}>CJL</div>,
      dataIndex: "codej",
      key: "codej",
      align: "right",
      render: (text) => <div style={{ paddingRight: 10 }}>{text}</div>,
    },
    {
      title: <div style={columnHeaderStyle}>Date Saisie</div>,

      dataIndex: "datesaisie",
      key: "datesaisie",
      align: "right",
      render: (text, record) => (
        <div style={{ whiteSpace: "nowrap", textAlign: "center" }}>
          {moment().locale("fr").format("DD MMM YYYY")}
        </div>
      ),
    },
    {
      title: <div style={columnHeaderStyle}>Cpte.Gen.</div>,
      dataIndex: "comptegen",
      key: "comptegen",
      align: "right",
      render: (text) => (
        <div style={{ paddingRight: 10 }}>{parseFloat(text)}</div>
      ),
    },
    {
      title: <div style={columnHeaderStyle}>Libellé</div>,

      dataIndex: "libelle",
      key: "libelle",
      align: "right",
      render: (text) => <div style={{ paddingRight: 10 }}>{text}</div>,
    },
    {
      title: <div style={columnHeaderStyle}>Débit</div>,

      dataIndex: "debit",
      key: "debit",
      align: "right",
      render: (text) => (
        <div style={{ paddingRight: 10 }}>
          {new Intl.NumberFormat("fr-FR", {
            style: "decimal",
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
          }).format(parseFloat(text))}
        </div>
      ),
    },
    {
      title: <div style={columnHeaderStyle}>Crédit</div>,

      dataIndex: "credit",
      key: "crecit",
      align: "right",
      render: (text) => (
        <div style={{ paddingRight: 10 }}>
          {new Intl.NumberFormat("fr-FR", {
            style: "decimal",
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
          }).format(parseFloat(text))}
        </div>
      ),
    },
  ];

  return (
    <Modal
      width="fit-content"
      style={{ top: 20 }}
      title="Passation Comptable"
      open={isVisible}
      onCancel={handleClose}
      maskClosable={false}
      footer={[
        <Button key="back" danger onClick={handleClose}>
          Fermer
        </Button>,
        <Button
          style={{ backgroundColor: "#010f1c", color: "white" }}
          type="primary"
          onClick={handleComptabiliser}
        >
          Comptabiliser
        </Button>,
      ]}
    >
      <Table
        loading={loading}
        columns={detailColumns}
        showSorterTooltip={false}
        dataSource={data}
        className="custom-header2-table"
        bordered
        pagination={{
          pageSize: 10,
        }}
      />
    </Modal>
  );
};

export default PassComptaImmo;
